module.exports = __webpack_public_path__ + "static/media/UK-Sheffield.fa1be47f.jpg";